import React from 'react'
import { IIntakeStep } from './IIntakeStep'
import { IntakeStepButton } from './IntakeStepButton'
import { ANSWER_INDEX, ReviewStepRadioButtons } from './ReviewStepRadioButtons'

/* tslint:disable */
export const review4Steps: IIntakeStep[] = [
  {
    Component: IntakeStepButton, buttonLabel: 'Start', children: <div>
    In order to ensure that the WebTIPS site is effective in teaching you everything you need to know about preparing for your child's surgery, we'd like to ask you a few questions about the section you just read. Just click the answer you think is correct!
      <br /><br />
    Once you've answered the questions, you'll be able to move on to the next section.
    </div>, completed: intake => !!intake.review4CheckedDescribeText,
    label: 'Home After Surgery review',
    name: 'review4CheckedDescribeText',
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review4OnceChildDischargedHowSoonEat,
    label: 'Once your child is discharged home after surgery, how soon will they be able to eat?',

    correctText: 'Right answer.',
    wrongText: 'The correct answer was B. ',
    crossOutIndexes: [
      ANSWER_INDEX.A,
      ANSWER_INDEX.C,
      ANSWER_INDEX.D,
    ],
    name: 'review4OnceChildDischargedHowSoonEat', options: [{
      correct: false,
      label: 'A: My child can eat whatever they want after surgery, no matter how they feel',
      value: 'eatWhatever',
    }, {
      correct: true,
      label: 'B: Once my child is keeping down clear liquids, they can have soups and gradually work up to solid foods',
      value: 'liquidsGraduallySolid',
    }, {
      correct: false,
      label: 'C: My child will not be able to eat or drink anything for at least 24 hours after surgery',
      value: 'notEat24h',
    }, {
      correct: false,
      label: 'D: Solid foods are ok, but no liquids after surgery',
      value: 'onlySolids',
    }],
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review4AllSignsChildInPainExcept,
    label: 'Some of the subtle signs that your child is in pain after surgery include all of the following except:',
    correctText: 'Right answer. All other statements are true.',
    wrongText: 'The correct answer was C. All other statements are true.',
    crossOutIndexes: [
      ANSWER_INDEX.C,
    ],
    name: 'review4AllSignsChildInPainExcept', options: [{
      correct: false,
      label: 'A: Shivering or shuddering',
      value: 'shivering',
    }, {
      correct: false,
      label: 'B: Grimacing',
      value: 'grimacing',
    }, {
      correct: true,
      label: 'C: Increased showering or bathing',
      value: 'showering',
    }, {
      correct: false,
      label: 'D: Grabbing at or guarding the area of the body that hurts',
      value: 'grabbing',
    }],
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review4ReassuranceAtHome,
    label: 'Although reassurance was not recommended for helping my child with pain in the hospital, it’s best to ' +
    'reassure my child when they are in pain at home.',
    correctText: 'Right answer.',
    wrongText: 'The correct answer was B.',
    crossOutIndexes: [
      ANSWER_INDEX.A,
      ANSWER_INDEX.C,
      ANSWER_INDEX.D,
    ],
    name: 'review4ReassuranceAtHome', options: [{
      correct: false,
      label: 'A: True',
      value: 'true',
    }, {
      correct: true,
      label: 'B: False',
      value: 'false',
    }],
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review4BestWayManageParentAnxiety,
    label: 'Parents can still experience anxiety at home after their child’s surgery.  The best way to manage your ' +
    'anxiety is:',

    correctText: 'Right answer.',
    wrongText: 'The correct answer was D.',
    crossOutIndexes: [
      ANSWER_INDEX.A,
      ANSWER_INDEX.B,
      ANSWER_INDEX.C,
    ],
    name: 'review4BestWayManageParentAnxiety', options: [{
      correct: false,
      label: 'A: Asking others to reassure your worries',
      value: 'reassure',
    }, {
      correct: false,
      label: 'B: Focusing on what makes you anxious and writing it down',
      value: 'anxiousWritingDown',
    }, {
      correct: false,
      label: 'C: Talking to the neighbors about your child\'s surgery',
      value: 'talkingAbout',
    }, {
      correct: true,
      label: 'D: Deep breathing and guided imagery',
      value: 'deepBreathingAndGuidedImagery',
    }],
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review4AllTrueAboutManagingChildsPainAtHomeExcept,
    label: 'All of the following are true about managing your child’s pain at home except: ',

    correctText: 'Right answer. All other statements are true.',
    wrongText: 'The correct answer was C. All other statements are true.',
    crossOutIndexes: [
      ANSWER_INDEX.C,
    ],
    name: 'review4AllTrueAboutManagingChildsPainAtHomeExcept', options: [{
      correct: false,
      label: 'A: Using distraction can be helpful when your child is in pain at home',
      value: 'distraction',
    }, {
      correct: false,
      label: 'B: It is important to pay attention to your child’s behavior to help determine when they are in pain',
      value: 'payAttentionToBehavior',
    }, {
      correct: true,
      label: 'C: My child will always tell me if they are in pain so I don’t have to worry about paying attention to ' +
        'their behavior',
      value: 'willAlwaysTell',
    }, {
      correct: false,
      label: 'D: My child will probably have some pain after surgery, but there are lots of ways that it can be managed ' +
        'and to help my child deal with the pain',
      value: 'manyWaysToManagePain',
    }],
  },

]



// WEBPACK FOOTER //
// ./src/organisms/Intakes/review4Steps.tsx